<template>
	<div id="page-user-edit">
		<bread-crumbs
			v-if="activeTab === 0"
			:title="$t('Groups.Groups')"
			:subTitle="$t('general.SubtitleGroupsList')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<group-list-view
					v-if="groupReadPermission"
					@selectedGroupEmit="selectedGroupEmit"
					@valueCreateGroup="valueCreateGroupEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<group-form
					v-if="groupCreatePermission && groupData.id === 0"
					:data="groupData"
					@valueFormGroup="valueCreateGroupEmit"
				/>
				<group-form
					v-else-if="groupUpdatePermission && groupData.id > 0"
					:data="groupData"
					@valueFormGroup="valueCreateGroupEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
		</div>
	</div>
</template>

<script>
import Group from "@/models/Group.js";
import GroupListView from "./GroupListView.vue";
import GroupForm from "./GroupForm.vue";
import LockScreen from "@/views/pages/LockScreen.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	props: {
		data: {
			type: Group,
			default: () => {
				new Group({});
			},
		},
	},
	components: {
		GroupListView,
		GroupForm,
		LockScreen,
		NotPermission,
	},
	data() {
		return {
			groupData: new Group({}),
			user_not_found: false,
			activeTab: 0,
		};
	},
	computed: {
		nameTabOne() {
			return this.groupData.id > 0 ? this.$t("UpdateGroup") : this.$t("CreateGroup");
		},
		groupReadPermission() {
			return this.$store.getters.checkPermission("GROUPS_R");
		},
		groupCreatePermission() {
			return this.$store.getters.checkPermission("GROUPS_C");
		},
		groupUpdatePermission() {
			return this.$store.getters.checkPermission("GROUPS_U");
		},
	},
	methods: {
		selectedGroupEmit(group) {
			this.groupData = group;
			this.activeTab = 1;
		},
		valueCreateGroupEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.groupData = new Group({});
			}
		},
	},
};
</script>
